import Swiper from 'swiper';
import { FreeMode, Autoplay } from 'swiper/modules';

import breakpoints from '@utils/breakpoints.js';

const SELECTOR_CAROUSEL = '.js-carousel';
const SPEEEEED = 22222;

const init = () => {
  const swiper = new Swiper(SELECTOR_CAROUSEL, {
    modules: [FreeMode, Autoplay],
    loop: true,
    speed: SPEEEEED,
    zoom: true,
    slidesPerView: 2.5,
    freeMode: {
      enabled: true,
      momentum: true,
      momentumBounce: false,
      momentumRatio: 0.5,
      momentumVelocityRatio: 0.5,
    },
    autoplay: {
      enabled: true,
      delay: 0,
      pauseOnMouseEnter: false,
      disableOnInteraction: false,
    },
    centeredSlides: true,
    navigation: false,
    breakpoints: {
      0: {
        slidesPerView: 1,
      },
      [breakpoints.sm]: {
        slidesPerView: 1.5
      },
      [breakpoints.md]: {
        slidesPerView: 2.5
      },
      [breakpoints.lg]: {
        slidesPerView: 3.5
      },
    },
  });
};

export default {
  init
}
